import { RouteRecordRaw } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default [
  {
    path: '/pricing',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Pricing',
        component: () =>
          import(
            /* webpackChunkName: "payment" */ '@/views/membership/Membership.vue'
          ),
      },
      {
        path: 'limited',
        name: 'LimitedOffer',
        component: () =>
          import(
            /* webpackChunkName: "limited-offer" */ '@/views/limited-offer/LimitedOffer.vue'
          ),
      }
    ],
  },
] as RouteRecordRaw[];
